import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IAdminEmailView } from 'app/models/admin/admin';
import { IAdministrativeComplaintView } from 'app/models/mainMenu/mainMenu';
import { IComplaintSearchViewModel } from 'app/models/search/search';
import { ISelectItems } from 'app/models/shared/shared';
import { AdminService } from 'app/services/admin/admin.service';
import { ComplaintService } from 'app/services/complaint/complaint.service';

@Component({
  selector: 'app-additionalComplaints',
  templateUrl: './additionalComplaints.component.html',
  styleUrls: ['./additionalComplaints.component.scss']
})

export class AdditionalComplaintsComponent implements OnInit {
  @Input() businessId: string = '';
  list: IAdministrativeComplaintView[] = [];
  currentEmail: IAdminEmailView;
  filter: string = '';
  showList: boolean = true;
  countyList: ISelectItems[] = [];
  currentComplaint: IAdministrativeComplaintView = null;

  searchParameters: IComplaintSearchViewModel;

  displayedColumns: string[] = ['complaintId', 'complaintDate', 'complaintStatus', 'correspondence'];

  dataSource = new MatTableDataSource<IAdministrativeComplaintView>(this.list);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;


  constructor(public adminService: AdminService,
    public complaintService: ComplaintService,
    public sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.getData();
    this.dataSource.data = this.list;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.countyList = this.sharedService.countyDropDownList;
    this.showList = true;
  }

  rowClick(row: IAdministrativeComplaintView) {
    this.showList = false;
    this.complaintService.complaintId = +row.complaintId;
    this.sharedService.doRedirect('complaint/complaint/'+row.complaintId);

  }

  getData() {
    if (this.businessId != null && this.businessId != '') {
      this.adminService.otherBusinessComplaints(this.businessId).subscribe({
        next: response => {
          this.list = response;
          this.dataSource.data = this.list;
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.showList = true;
        },
        error: e => {
          this.sharedService.toastr.error("Could not get Complaint Data");
        },
      });
    }
    else {
      this.list = [];
      this.showList = false;
    }
  }

  filterTable(event: Event) {
    this.dataSource.filter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase();
    this.filter = this.dataSource.filter;
  }

  cancel() {
    this.showList = true;
  }

}
